import { observer } from 'mobx-react';
import { BaseButton, ActionButton } from 'office-ui-fabric-react/lib/Button';
import { getRollupText } from 'owa-mail-focused-inbox-rollup-store';
import { updateWatermarkAndResetRollup } from 'owa-mail-focused-inbox-rollup-store';
import { onRollupClicked, FocusedInboxRollupStore } from 'owa-mail-focused-inbox-rollup-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { getFocusedFilterForTable } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';

const styles = require('./FocusedInboxRollup.scss');
const classNames = require('classnames/bind').bind(styles);
export interface FocusedInboxRollupProps {
    rollupState: FocusedInboxRollupStore;
    tableViewId: string;
    styleSelectorAsPerUserSettings: string;
}

@observer
export default class FocusedInboxRollup extends React.Component<FocusedInboxRollupProps, any> {
    private renderSingleLineRollup() {
        return (
            <div
                className={classNames(
                    this.props.styleSelectorAsPerUserSettings,
                    styles.firstRowContainer
                )}
                onClick={onRollupClicked}>
                <div
                    className={classNames(
                        this.props.styleSelectorAsPerUserSettings,
                        styles.firstColumn
                    )}>
                    {getRollupText(this.props.rollupState.viewType)}
                </div>
                {this.renderUniqueSenders()}
                {this.renderDismissButton()}
            </div>
        );
    }

    private renderThreeColumnRollup() {
        return (
            <div
                className={classNames(
                    this.props.styleSelectorAsPerUserSettings,
                    styles.threeColumnViewOuterContainer
                )}>
                <div className={styles.column} onClick={onRollupClicked}>
                    <div className={styles.firstLineTextThreeColumn}>
                        {getRollupText(this.props.rollupState.viewType)}
                    </div>
                    {this.renderUniqueSenders()}
                </div>
                {this.renderDismissButton()}
            </div>
        );
    }

    private renderDismissButton = (): JSX.Element => {
        return (
            <ActionButton
                className={styles.dismissButton}
                onClick={this.onDismiss}
                iconProps={{
                    iconName: ControlIcons.Cancel,
                }}
            />
        );
    };

    private renderUniqueSenders = (): JSX.Element => {
        return <div className={styles.secondLineText}>{this.props.rollupState.uniqueSenders}</div>;
    };

    private onDismiss = (evt: React.MouseEvent<BaseButton>) => {
        evt.stopPropagation();
        const tableView = listViewStore.tableViews.get(this.props.tableViewId);
        const focusedViewFilter = getFocusedFilterForTable(tableView);
        updateWatermarkAndResetRollup(focusedViewFilter, 'ExitRollupButton');
    };

    render() {
        const isReadingPanePositionRight: boolean =
            getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ===
            ReadingPanePosition.Right;

        if (this.props.rollupState.uniqueSenders) {
            return isReadingPanePositionRight
                ? this.renderThreeColumnRollup()
                : this.renderSingleLineRollup();
        }

        return null;
    }
}
